(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Country', '$uibModal', 'CountryCustomService'];

    function CountryDetailController($scope, $rootScope, $stateParams, previousState, entity, Country, $uibModal, CountryCustomService) {
        var vm = this;

        vm.country = entity;
        vm.previousState = previousState.name;
        vm.ports = [];

        vm.loadPorts = loadPorts;

        var unsubscribe = $rootScope.$on('ccsTrApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.loadPorts();

        vm.editCountry = function() {
            $uibModal.open({
                templateUrl: 'app/entities/country/country-dialog.html',
                controller: 'CountryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['Country', function(Country) {
                        return Country.get({id : $stateParams.id}).$promise;
                    }]
                }
            }).result.then(function() {

            }, function() {

            });
        };

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.createTab = function (data) {
            $scope.$emit('handleEmit', data);
        };

        function loadPorts() {
            CountryCustomService.returnAllPortsByCountry(vm.country.id).then(function (data) {
                vm.ports = data.data;
            }, function (error) {
                vm.ports = [];
            });
        }
    }
})();
